/**
 * Created by Ivan on 24.05.2026
 */

const SeasonPassPurchaseWindow = Prefab.createWindow(
    "season_pass_purchase_window",
    "purchase_window_prefab_json",
    {
        theme: (mission) => bundles[`season_pass_${mission.logic.period}`].jsons[`theme_${mission.logic.period}`],
        bundles: SeasonPassLogic.listWindowBundles
    }
);
